import { HTTP } from '../../http-common'

export default {
  state: {
    loadedCountries: []
  },
  getters: {
    loadedCountries (state) {
      return state.loadedCountries
    }
  },
  mutations: {
    setLoadedCountries (state, payload) {
      state.loadedCountries = payload
    },
    createCountry (state, payload) {
      state.loadedCountries.push(payload)
    },
    updateCountry (state, payload) {
      state.loadedCountries = state.loadedCountries.map(country => country.id === payload.id ? payload : country)
    },
    removeCountry (state, id) {
      state.loadedCountries = state.loadedCountries.filter(country => {
        return country.id !== id
      })
    },
    clearLoadedCountries (state) {
      state.loadedCountries = []
    }
  },
  actions: {
    loadCountries ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedCountries', [])

      return new Promise((resolve, reject) => {
        HTTP.get('country.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedCountries', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createCountry ({ commit, getters }, payload) {
      console.log('createCountry')
      commit('clearError')
      commit('setLoading', true)
      const newCountry = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('country.json/', newCountry)
          .then(result => {
            console.log(result)
            commit('createCountry', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateCountry ({ commit, getters }, payload) {
      console.log('updateCountry')
      commit('clearError')
      commit('setLoading', true)
      const country = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`country.json/${payload.id}/`, country)
          .then(result => {
            console.log(result)
            commit('updateCountry', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeCountry ({ commit }, payload) {
      console.log('removeCountry')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`country.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeCountry', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedCountries ({ commit }) {
      commit('clearLoadedCountries')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/country/index.js